import { render, staticRenderFns } from "./MenuDropdownContent.vue?vue&type=template&id=0906f786&"
import script from "./MenuDropdownContent.vue?vue&type=script&lang=js&"
export * from "./MenuDropdownContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports